const emitterProps = {
  cart: {
    get: 'cart.get',
    add: 'cart.add',
    update: 'cart.update',
    clear: 'cart.clear',
    count: 'cart.count',
    change: 'cart.change',
    render: 'cart.render',
    editGift: 'cart.edit_gift'
  },
  product: {
    updateVariant: 'product.update_variant',
    openQuickAdd: 'product.open_quick_add'
  },
  notice: {
    global: 'notice.global'
  },
  slideout: {
    login: 'slideout.login',
    register: 'slideout.register'
  }
}

class GlobalEmitter {
  emit (name, payload) {
    const event = new CustomEvent(name, {
      detail: payload
    })

    document.dispatchEvent(event)
  }

  on (name, callback) {
    document.addEventListener(name, (e) => {
      callback(e.detail)
    })
  }

  off (name, callback) {
    document.removeEventListener(name, callback)
  }
}

const globalEmitter = new GlobalEmitter()

export {
  emitterProps,
  globalEmitter
}
